var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-link', {
    directives: [{
      name: "margin",
      rawName: "v-margin",
      value: (1),
      expression: "1"
    }],
    class: _vm.theme.card,
    attrs: {
      "href": _vm.link,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.poster,
      "claass": _vm.theme.poster
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding",
      value: (2),
      expression: "2"
    }]
  }, [(_vm.date) ? _c('div', [_c('v-text', {
    attrs: {
      "type": "caption"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.moment(_vm.date).format('DD.MM.YYYY')) + "\n            ")])], 1) : _vm._e(), _vm._v(" "), _c('v-text', {
    attrs: {
      "bold": "",
      "claass": _vm.theme.title
    }
  }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n        ")])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c10d7b8","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/trainingCard/TrainingCard.vue
// module id = 1042
// module chunks = 0